import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

export const useBossModeStatsLinks = () => {
  const { t } = useTranslation();

  return useMemo(
    () => [
      {
        to: '../forensics',
        label: t('forensics'),
      },
      {
        to: '../suggested-actions',
        label: t('suggestedActionsLc'),
      },
    ],
    [t],
  );
};

export default useBossModeStatsLinks;
